import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

type PaymentGateway = 'stripe' | 'consolidated'

export interface Product {
  type: 'addon' | 'contract'
  quantity: number
  id: string
}

export const useFetchPayment = () => {
  const { post } = useFetchWithDefaults()
  const create = (
    { workspaceId, payment }: WorkspaceIdentifier & { payment: { gateway?: PaymentGateway, products: Product[] } },
  ) => post({
    url: '/me/payments',
    workspaceId,
    fetchOptions: {
      body: payment,
    },
  })

  return {
    create,
  }
}
